export default __webpack_public_path__ + "static/media/Strugani 21.b26f0237.jpg";